// Role-label helpers. The role IDs in the database / API stay `admin`,
// `subadmin`, `user`, `readonly` everywhere — these helpers exist purely for
// the displayed label, which the user team renamed:
//
//   admin    → "Super Admin"    (the original full-power account)
//   subadmin → "Admin"          (the delegated user-manager; what most ops people see)
//   user     → "User"
//   readonly → "Read-only"
//
// Background: as the team grew, the day-to-day "admin" role became the
// delegated user-manager (formerly "subadmin"), and the original full-power
// account is now a rarer "Super Admin". The IDs aren't renamed because every
// role-id literal across SQL, Go handlers, and the auth middleware would
// otherwise need a migration — a label remap covers the actual ask.

const LABELS = {
  admin: 'Super Admin',
  subadmin: 'Admin',
  user: 'User',
  readonly: 'Read-only',
  backup: 'Backup Operator',
};

// roleLabel maps a role id to its display label. Falls back to the raw id (a
// new role added without a label) so a missing entry surfaces visibly instead
// of rendering blank.
export function roleLabel(role) {
  return LABELS[role] || role || '';
}
